export enum ResponseType {
    Text = 'Text',
    Video = 'Video',
}